function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.391 17.153l-3.922 3.69h22.805c.406 0 .726.298.726.677 0 .38-.32.679-.726.679H3.469l3.922 3.662c.29.27.29.705 0 .95a.728.728 0 0 1-.523.189.728.728 0 0 1-.523-.19L1.203 22.01A.63.63 0 0 1 1 21.52c0-.19.087-.352.203-.488l5.171-4.829c.29-.27.756-.27 1.017 0 .29.272.29.706 0 .95zM1 6.507c0 .379.32.676.727.676h22.83l-3.955 3.68c-.291.271-.291.704 0 .948a.73.73 0 0 0 .523.189.73.73 0 0 0 .524-.19l5.147-4.816A.628.628 0 0 0 27 6.507a.749.749 0 0 0-.204-.487L21.62 1.203c-.291-.27-.756-.27-1.018 0-.291.27-.291.704 0 .947l3.926 3.653h-22.8C1.32 5.83 1 6.128 1 6.507z"
});

function SvgChange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.60b58b35.svg";
export { ForwardRef as ReactComponent };